import { getAppName, getTheme } from "@/features/branding";
import { Image } from "antd";
import Link from "next/link";
export const AppName = () => {
  const theme = getTheme();
  const logo = theme.meta.logoIconUrl || theme.meta.logoUrl;
  return <Link href="/" className="!text-gray-700 !no-underline" data-sentry-element="Link" data-sentry-component="AppName" data-sentry-source-file="AppName.tsx">
      <div className="flex items-center gap-2">
        {logo && <div className="h-8 w-auto">
            <Image src={logo} alt="Logo" preview={false} className="!h-8 !w-auto" />
          </div>}
        <div className="overflow-hidden text-lg font-semibold">{getAppName()}</div>
      </div>
    </Link>;
};